export default function Footer() {
  return (
    <footer id="footer" className="w-full text-cream-100/75 relative overflow-hidden">
      {/* Video background - landscape */}
      <div className="absolute inset-0 w-full h-full">
        <video
          autoPlay
          muted
          loop
          playsInline
          className="w-full h-full object-cover scale-105"
          src="https://storage.readdy-site.link/project_files/d891e450-b88b-4862-a138-b46b8b4d4b90/f576cab5-8d68-4f3d-96f2-251110d3d10d_20250616_Romeo_Y_Julieta_Cupidos_Habanos_Specialist.mp4"
        />
        <div className="absolute inset-0 bg-espresso-900/80" />
      </div>

      {/* Upper section */}
      <div className="relative z-10 py-9 px-6">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div>
            <div className="flex items-center gap-3">
              <span className="w-9 h-9 rounded-full bg-gold-400/10 border border-gold-400/40 flex items-center justify-center overflow-hidden">
                <img
                  src="https://storage.readdy-site.link/project_files/d891e450-b88b-4862-a138-b46b8b4d4b90/34dcd580-fc50-47e7-b8cf-0afc18add05d_compressed_logo.webp"
                  alt="AOCigar logo"
                  className="w-full h-full object-contain p-0.5"
                />
              </span>
              <div>
                <div className="font-display text-lg text-cream-50">AOC · 百汇茄社</div>
                <div className="text-[11px] font-sc tracking-widest text-gold-300">A CIGAR & WINE ATELIER</div>
              </div>
            </div>
            <p className="mt-3 text-xs font-sc leading-relaxed max-w-md">
              我们致力于为大家提供最优质的雪茄产品和专业的服务。无论你是雪茄爱好者还是新手，期待与你一起探索雪茄世界的美味！
            </p>
          </div>
        </div>
      </div>

      {/* Lower section */}
      <div className="relative z-10 pt-0 pb-5 px-6">
        <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-2 text-[11px] font-sc text-cream-100/50">
          <div>© 2026 百汇茄社. 保留所有权利. 未成年人禁止吸烟 · 吸烟有害健康</div>
          <div className="flex items-center gap-4">
            <a href="#" className="hover:text-gold-300 transition-colors">用户协议</a>
            <a href="#" className="hover:text-gold-300 transition-colors">隐私政策</a>
          </div>
        </div>
      </div>
    </footer>
  );
}